<template>
  <div class="pageContent">
    <pageTitle title="用户中心"/>
    <inputBox :disabled='true' label='卡号' :value='g_UserInfo.Card_no' />
    <!--可编辑或者不可编辑-->
    <inputBox v-if='!CanChangeName' :disabled='true' label='姓名' :value='UserName' :extendType='IsChange?"icon":""' :extendSrc='require("../../assets/svg/pen.svg")' @extendHandler='ChangeName' />
    <!--编辑中-->
    <inputBox v-else label='姓名' v-model='SetName' extendType='button' :extendSrc=' SetName=="" ?"取消":"保存"' @extendHandler='SaveName' hintMsg='您的新姓名' />
    <inputBox :disabled='true' label='性别' :value='g_UserInfo.SexDisplay' />
    <inputBox :disabled='true' label='手机' :value='g_UserInfo.sjno' extendType='icon' />
    <!-- <inputBox :disabled='true' label='手机' :value='g_UserInfo.sjno' extendType='icon' :extendSrc='require("../../assets/svg/pen.svg")' @extendHandler='changePhone'/> -->
    <inputBox v-if='!CanChangeCardID' :disabled='true' label='身份证' :value='cardID'/>
    <inputBox v-else label='身份证' v-model='SetCardID' extendType='button' :extendSrc='SetCardID == ""?"取消":"保存"' @extendHandler='SaveCardID' hintMsg='请输入您的身份证号'/>
    <inputBox :disabled='true' label='邮箱' :value='g_UserInfo.Email' extendType='icon' :extendSrc='require("../../assets/svg/pen.svg")' @extendHandler='changeMail' />
    <mu-toast v-if="toast" v-bind:message="this.TellUser" @close="hideToast" id="alertline" />
  </div>
</template>




<style lang="less" scoped="">
@import "../../assets/theme.less";



#greenfont {
  color: @primaryColor ;
}

.pageContent {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  font-size: 110%;

  .title {
    font-size: 110%;
    color: #333333;
    width: 20%;
    height: 0.65rem;
  }
}
</style>





<script>


import { mapMutations, mapGetters } from 'vuex'
import api from '../../api'



export default {
  data() {
    return {
      CanChangeName: false,
      CanChangeCardID:false,
      cardID:'',
      SetCardID:'',
      SetName: '',
      IsChange: false,


      // 弹出层
      toast: false,
      // 弹出标签 选择是否
      dialog: false ,
      UserName: '',
    }
  },
  activated() {
    this.UserName = this.g_UserInfo.Name;

    this.CanChangeName = false;

    // 这是校验是否是手机号，但是只包含数字就能修改。
    // if(!(/^1[3|4|5|8][0-9]\d{4,8}$/.test(this.g_UserInfo.Name))){ 

    if((/(.*)?\d+(.*)?$/.test(this.UserName))){ 
      this.IsChange = true;
    }
    else{
      this.IsChange = false;
    }
    if(this.g_UserInfo.zjno != undefined && 
       this.g_UserInfo.zjno != '' &&
       ((this.g_UserInfo+'').length == 15 || (this.g_UserInfo+'').length == 18)){
         this.cardID = (this.g_UserInfo.zjno + '').substring(0,6) + '********' + this.g_UserInfo.zjno.substring(14);
         this.CanChangeCardID = false;
    }
    else{
      this.cardID = '';
      this.CanChangeCardID = true;
    }
    var params = new this.URLSearchParam();
    params.append('cardNo', this.g_UserInfo.Card_no ? this.g_UserInfo.Card_no : '')
    this.$http.post(api.loginState(), params.toParam()).then((res) => {
      if (res.Result) {
        // this.loginState = true
      }
      else {
        // this.$http.post(api.LogOff()).then((res) => { });
        this.$store.commit('CLEARUSER');
        // this.loginState = false;
          this.TellUser = res.Message;
          this.showToast();
      }
    });

    // 20180108 临时修复BUG，数据不对强制重登    
    if( this.g_UserInfo.SexDisplay == undefined ){
        this.TellUser = "信息错误，请重新登录。";
        this.showToast();
        this.$http.post(api.LogOff()).then((res) => {           });
        this.$store.dispatch('clearUser');
        this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 1600)
    }

    // TODO:修改姓名跳转到 用户信息页面
    if(window.location.href.indexOf("/user/UserCenter") > -1){
      window.history.go(-1);
    }
  },
  // 数据获取
  computed: {
    ...mapGetters([
      'g_UserInfo',
    ])
  },
  methods: {
    ...mapMutations([
      'setG_UserInfo',
    ]),


    SaveName() {
      if (this.SetName == '') {
        //取消流程
        this.CanChangeName = false
        return
      }
      //保存流程
      var reg = new RegExp("^[0-9]*$");
      if (reg.test(this.SetName)) {
        this.TellUser = '姓名只允许中文和英文字母';
        this.showToast();
        return
      }
      var params = new this.URLSearchParam();
      params.append('name', this.SetName);
      this.$http.post(api.ChangeAll(), params.toParam()).then((res) => {
        if (res.Result == true) {
          this.TellUser = res.Data;
          this.showToast();
          // 修改缓存中的邮箱
          var UserInfo = this.g_UserInfo;
          UserInfo.Name = this.SetName;
          this.setG_UserInfo(UserInfo);
          setTimeout(() => { 
            if(window.history.length >= 1){
              window.history.go(-1);
            }
            else{
              this.$router.push({ path: '/user/UserCenter' })
            } 
          }, 1500)
        }
        else {  //登陆失败
          this.TellUser = res.Message;
          this.showToast();
        }
      })
    },
    SaveCardID(){
      if(this.SetCardID == ''){
        this.TellUser = '请输入身份证号！';
        this.showToast(); 
        return  false;
      }
      var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if(reg.test(this.SetCardID) === false){ 
        this.TellUser = '身份证格式错误！';
        this.showToast(); 
        return  false;
      }
      var params = new this.URLSearchParam();
      params.append('zjKind', 1);
      params.append('zjno', this.SetCardID);
      this.$http.post(api.ChangeAll(), params.toParam()).then((res) => {
        if (res.Result == true) {
          this.TellUser = res.Data;
          this.showToast();
          // 修改缓存中的邮箱
          var UserInfo = this.g_UserInfo;
          UserInfo.zjno = this.SetCardID;
          this.setG_UserInfo(UserInfo);
          setTimeout(() => { 
            if(window.history.length >= 1){
              window.history.go(-1);
            }
            else{
              this.$router.push({ path: '/user/UserCenter' })
            }          
          }, 1500)
        }
        else {  //登陆失败
          this.TellUser = res.Message;
          this.showToast();
        }
      })
    },

    ChangeName() {
      this.CanChangeName = true;

      // this.SetName = this.g_UserInfo.Name;

      this.SetName = '';

    },

    // 后退一页
    goback() {
      javascript: history.go(-1);
    },

    // 弹出层
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1000)
      if (this.TellUser == '未登录') {
        this.$http.post(api.LogOff()).then((res) => { });
        this.$store.dispatch('clearUser');
        this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 1500)
      }
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    // 弹出层  end
    //修改手机
    changePhone(){
      this.$router.push({ path: '/user/ChangePhone' })
    },
    changeMail(){
      this.$router.push({ path: '/user/ChangeEMail' })
    },
    // ChangeCardID(){
    //   this.$router.push({path:'/user/ChangeCardID'})
    // }
  }

}

</script>










// WEBPACK FOOTER //
// BaseInfo.vue?54d32916